export default "__VITE_ASSET__D6iR5$yT__"